// extracted by mini-css-extract-plugin
module.exports = {"title":"IndexedTitle-module--title--1VEnH","number":"IndexedTitle-module--number--20iVJ"};